// Favorites.js

import React, { useContext } from 'react';
import { PRODUCTS } from '../../product';
import { ShopContext } from '../../context/shop-context';
import FavoriteItem from './favorites-item';
import "./favorites.css";
import { useNavigate } from "react-router-dom";
import { Link} from "react-router-dom";

function Favorites() {
const { favoriteItems } = useContext(ShopContext);

const navigate = useNavigate();

return (
<div className='favorites'>
  <h1>Favorites</h1>
  <div className='favoriteItems'>
    {favoriteItems.length > 0 ? (
      PRODUCTS.map((product) => {
  if (favoriteItems.includes(product.id)) {
    return <FavoriteItem key={product.id} data={product} />;
  }
})
    ) : (
    <div className='no-favorites'>
      <Link to="/">
      <img style={{display:"flex", justifyContent:"center",margin:"auto"}}
        src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTG8TqttyLDdGlH5xzgbJajueL0XPZUf_DU40lOARoAz-cwVF40gFa3mOk32umks_g730Y&usqp=CAU"
        alt="No Favorites" />
      </Link>
      <h1>No favorites yet.</h1>
      <h2>Click to heart icon and you'll see it next time you visit.</h2>
    </div>
    )}
  </div>
  <div className="checkout">
    <button onClick={()=> navigate("/")}> Continue Shopping </button>
  </div>
</div>
);
}

export default Favorites;